import { render, staticRenderFns } from "./ProductsTiles.vue?vue&type=template&id=42684275"
import script from "./ProductsTiles.vue?vue&type=script&lang=js"
export * from "./ProductsTiles.vue?vue&type=script&lang=js"
import style0 from "./ProductsTiles.vue?vue&type=style&index=0&id=42684275&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports